<template>
  <span class="sub-title1">{{ $translation($websiteText().checkout_payment_method_sentence)}}</span>
  <div class="note-payment" v-if="showRefundMessage">
    <div
      class="note-payment-title"
      style="font-weight: 500; border-bottom: solid 1px black; width: 100px"
    >
    {{ $translation($websiteText().checkout_payment_method_please_note)}}
    </div>
    <div class="note-1">
      <svg
        width="20"
        style="width: 50px"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 3V7H17.66C17.9499 6.99672 18.2371 7.0565 18.5016 7.17522C18.7661 7.29393 19.0016 7.46873 19.1919 7.68751C19.3821 7.90629 19.5225 8.16382 19.6033 8.44225C19.6842 8.72068 19.7035 9.01336 19.66 9.3L18.28 18.3C18.2077 18.7769 17.9654 19.2116 17.5979 19.524C17.2304 19.8364 16.7623 20.0055 16.28 20H6L6 6.75L9 0C9.79565 0 10.5587 0.316071 11.1213 0.87868C11.6839 1.44129 12 2.20435 12 3ZM4 20L4 9H2C1.46957 9 0.960859 9.21071 0.585786 9.58579C0.210714 9.96086 0 10.4696 0 11V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H4Z"
          fill="#52C41A"
        />
      </svg>
      <span class="up-text">
        {{ $translation($websiteText().checkout_payment_method_note_sentence)}}
      </span>
    </div>
  </div>
  <br /><br/>
  <div class="payment-options">
    <template v-for='method in $store.getters.payment_methods' :key="method.id">
      <t-button
      v-if='method.status'
      style="margin-left:5px"
      :label="$translation(method.name)"
      :buttonClass="step.value == method.id ? 'button-active' : 'button-inactive'"
      @click="changeStep(method.id)"
      :style="{ 'margin-right': '-2px' , 'padding-left':'15px' , 'padding-right':'15px' }"
    />
    
  </template>
    
   
  </div>
  <template v-if="step.value == 4">
    <wiretransfer
      :paymentDoneAction="paymentDoneActionWire"
      :total="totalAmount"
      :currency="$store.getters.currency"
    ></wiretransfer>
  </template>
  <template v-if="step.value == 3">
    <card
      :paymentDoneAction="paymentDoneActionCard"
      :total="totalAmount"
      :currency="$store.getters.currency"
    ></card>
    <br />
  </template>
  <template v-if="step.value == 2">
    <PayPal
      :total="totalAmount"
      :currency="$store.getters.currency"
    ></PayPal>
    <br />
  </template>
</template>

<script>
import Wiretransfer from "./Wiretransfer.vue";
import Card from "./Card.vue";
import PayPal from "./PayPal.vue";
import TButton from "../../../../../common/components/buttons/TButton.vue";
import { reactive } from "@vue/reactivity";
import { computed } from "@vue/runtime-core";
import store from "../../../../../store";
import {GET_PRICE_BREAKDOWN,EDIT_ALL_ORDER_DETAILS} from "../../../store/actions";

export default {
  components: { TButton, Wiretransfer, Card,PayPal },
  setup(props) {
    const step = reactive({
      value: 2,
    });

    const initPaymentMethods = async ()=>
    {
      await store.dispatch("getPaymentMethods")
      for (let i=0;i<store.getters.payment_methods.length;i++)
      {
        if(store.getters.payment_methods[i].status)
        {
          step.value = store.getters.payment_methods[i].id
          store.commit("paymentMethodSelected", store.getters.payment_methods[i].id);
          store.commit('updatePaymentMethod',store.getters.payment_methods[i].id);
        }
      }
    }

    initPaymentMethods()

    step.value = 2

    const totalAmount = computed(() => {
      return props.amount
    });

    const changeStep = async (value) => {
      store.commit("paymentMethodSelected", value);
      step.value = value;
      store.commit('updatePaymentMethod',value);
      await store.dispatch(EDIT_ALL_ORDER_DETAILS)
      await store.dispatch(GET_PRICE_BREAKDOWN);
    };

    return {
      step,
      changeStep,
      totalAmount,
    };
  },
  props: {
    showRefundMessage: {
      default: false,
    },
    paymentDoneActionCard: Function,
    paymentDoneActionWire: Function,
    paymentDoneActionPayPal: Function,
    amount: Number,
    currency: Object,
  },
};
</script>

<style lang='scss'>
.payment-methods-container{
  background-color: $background-color;
  padding:20px;
}
.sub-title1{
  @include f-body1;
  color:black;
}

</style>